import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../common/loader/Loader";
import { useDispatch } from "react-redux";
import { setForgetPassword } from "../../redux/slice/Slice";
import Api_Instance from "../../api/Api_Instance";
import { forgetpassword } from "../../api/endpoints";
import toast from "react-hot-toast";

function Otp({ login }) {
    const dispatch = useDispatch();
    const api = Api_Instance.unAuth();
    const [otp, setOtp] = useState(["", "", "", "", ""]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const handleChange = (index, value) => {
        if (value.length > 1) return;
        const updatedOtp = [...otp];
        updatedOtp[index] = value.replace(/[^0-9]/g, "");
        setOtp(updatedOtp);
        if (value && index < otp.length - 1) {
            document.getElementById(`otp${index + 1}`).focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            document.getElementById(`otp${index - 1}`).focus();
        }
    };

    const validate = () => {
        let isValid = true;
        const errorMessages = {};
        if (otp.some((digit) => !digit.trim())) {
            isValid = false;
            errorMessages.otp = "All fields are required.";
        }

        setErrors(errorMessages);
        return isValid;
    };


    const handleSubmit = async () => {
        if (!validate()) return;
        setLoading(true);
        const otpCode = otp.join("");
        setTimeout(async () => {
            try {
                const res = await api("POST", `${forgetpassword?.POST_OTP}?email=${login?.email}`, { otp: otpCode })
                console.log(res?.data?.status)
                if (res?.data?.status == true) {
                    toast.success(res?.data?.message);
                    dispatch(setForgetPassword({
                        email: false,
                        otp: false,
                        confirmpassword: true
                    }))
                } else {
                    toast.error(res?.data?.message);
                }

            } catch (error) {
                toast.error(error?.response?.data?.message);
            } finally {
                setLoading(false)
            }

        }, 1000);
    };
    const enterKye = (e) => {
        if (e.key === "Enter") {
            e.preventDefault()
            handleSubmit()
        }
    }
    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 backdrop-blur-sm px-5">
            <div className="relative bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <button
                    className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                    onClick={() => dispatch(setForgetPassword({
                        email: false,
                        otp: false,
                        confirmpassword: false
                    }))}
                >
                    <FontAwesomeIcon icon={faTimes} size="lg" />
                </button>
                <div className="text-center mb-6">
                    <h2 className="text-xl font-medium mb-2 text-text_color">
                        Enter Your Code
                    </h2>
                    <p className="text-[#B3B3B3] text-[16px] mt-2 mb-[40px]">
                        We sent a code to{" "}
                        <span className="text-[#0C5399] font-semibold">
                            {login?.email}
                        </span>
                    </p>
                </div>
                <form
                    onSubmit={(e) => e.preventDefault()}
                    className="max-w-md mx-auto"
                >
                    <div className="flex gap-5 justify-center mb-[65px]">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                id={`otp${index}`}
                                type="text"
                                name={`otp${index}`}
                                value={digit}
                                maxLength="1"
                                className="appearance-none border max-w-[47px] rounded w-full py-2 text-center text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                onChange={(e) => handleChange(index, e.target.value)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                onKeyPress={enterKye}
                            />
                        ))}
                    </div>
                    {errors.otp && (
                        <p className="text-red-500 text-sm text-center">{errors.otp}</p>
                    )}
                    <div className="flex items-center justify-between mb-4">
                        <button
                            className="bg-primaryColor text-white w-full font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex items-center justify-center transition-all mb-[50px]"
                            type="button"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? <Loader /> : "Continue"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Otp;
